import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { IconCianMagazine20 } from '../../../Icons';
import * as s from './MainItemLabel.css';

/**
 * Лейбл-ссылка на Главную
 */
export const MainItemLabel = () => {
  const handleClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <Link to={'/magazine/'} className={s['link']} onClick={handleClick}>
      <IconCianMagazine20 color={'white_100'} />
      Циан.Журнал
    </Link>
  );
};
